import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient } from '@angular/common/http'

/**
 * Factory used for translate module. The loader returned is fetching data from local file in assets.
 * By default file are 'lang' + '.json'
 * Exemple : 'fr.json' or 'uk.json'
 *
 * @returns The loader used by TranslateModule
 */
export function TranslateLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json')
}
